import { useContext } from 'react';
import { DarkModeContext } from 'Configuration/DarkModeContext';

export const useDarkMode = () => {
  const context = useContext(DarkModeContext);

  if (!context) {
    throw new Error('useDarkMode must be used within DarkModeProvider');
  }

  return {
    darkMode: context.darkMode,
    setDarkMode: context.setDarkMode,
    toggleDarkMode: context.toggleDarkMode,
    agGridTheme: context.agGridTheme,
  };
};

export default useDarkMode;
